<template>
  <GerenciarUsuarios />
</template>

<script>
import GerenciarUsuarios from '@/components/utils/documentos/DocGerenciarUsuario.vue'
export default {
  components: {
    GerenciarUsuarios,
  },
}
</script>

<style></style>
